import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Button, Modal } from 'lib/ui'
import { ModalContent, ModalHeader, ModalAfterTitle, ModalFooter, ImageWrapper, InfoWrapper } from './styled'
import { useHistory } from 'react-router-dom'

interface Props {
  sku?: string
  isModalVisible?: boolean
  setIsModalVisible?: (param: boolean) => void
  productName?: string
  productImage?: string
  children?: JSX.Element | JSX.Element[]
  continueShoppingLink?: string
}

export const AddToCartModal = ({ sku, isModalVisible = false, setIsModalVisible, productName, productImage, children, continueShoppingLink }: Props) => {
  const history = useHistory()

  return (
    <Modal
      handleCloseModal={() => setIsModalVisible?.(!isModalVisible)}
      isOpen={isModalVisible}
    >
      <ModalContent>
        <ModalHeader>
          Product Added to Cart
        </ModalHeader>
        <ModalAfterTitle>
          <ImageWrapper>
            <img alt={productName} src={productImage} />
          </ImageWrapper>
          <InfoWrapper>
            <div>
              <p>{productName}</p>
              <span>SKU: {sku}</span>
            </div>
            {children}
          </InfoWrapper>
        </ModalAfterTitle>
        <ModalFooter hasTwoButtons={!!continueShoppingLink}>
          <div>
            {continueShoppingLink && (
              <Button
                onClick={() => history.push(continueShoppingLink)}
              >
                <FormattedMessage
                  id='action.continueShopping'
                />
              </Button>
            )}
            <Button className='primary' onClick={() => history.push('/cart')}>
              <FormattedMessage
                id='action.viewCart'
              />
            </Button>
          </div>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
